// noinspection JSUnusedGlobalSymbols

import * as Apollo from '@apollo/client';

import { gql } from '@apollo/client';
import type * as Types from '../../__generated__/types';

const defaultOptions = {} as const;
export type UpdateEmployeeEmergencyContactMutationVariables = Types.Exact<{
  input: Types.UpdateEmployeeEmergencyContactInput;
}>;

export type UpdateEmployeeEmergencyContactMutation = { __typename?: 'Mutation' } & {
  updateEmployeeEmergencyContact: { __typename?: 'EmployeeEmergencyContactOutput' } & Pick<
    Types.EmployeeEmergencyContactOutput,
    'id'
  > & {
      emergencyContact: { __typename?: 'EmployeeEmergencyContact' } & {
        phoneNumber: { __typename?: 'PhoneNumber' } & {
          country: { __typename?: 'Country' } & Pick<Types.Country, 'isdCode'>;
        };
      };
    };
};

export const UpdateEmployeeEmergencyContactDocument = /*#__PURE__*/ gql`
    mutation updateEmployeeEmergencyContact($input: UpdateEmployeeEmergencyContactInput!) {
  updateEmployeeEmergencyContact(input: $input) {
    id
    emergencyContact {
      phoneNumber {
        country {
          isdCode
        }
      }
    }
  }
}
    `;
export type UpdateEmployeeEmergencyContactMutationFn = Apollo.MutationFunction<
  UpdateEmployeeEmergencyContactMutation,
  UpdateEmployeeEmergencyContactMutationVariables
>;

/**
 * __useUpdateEmployeeEmergencyContactMutation__
 *
 * To run a mutation, you first call `useUpdateEmployeeEmergencyContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmployeeEmergencyContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEmployeeEmergencyContactMutation, { data, loading, error }] = useUpdateEmployeeEmergencyContactMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEmployeeEmergencyContactMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateEmployeeEmergencyContactMutation,
    UpdateEmployeeEmergencyContactMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateEmployeeEmergencyContactMutation, UpdateEmployeeEmergencyContactMutationVariables>(
    UpdateEmployeeEmergencyContactDocument,
    options,
  );
}
export type UpdateEmployeeEmergencyContactMutationHookResult = ReturnType<
  typeof useUpdateEmployeeEmergencyContactMutation
>;
export type UpdateEmployeeEmergencyContactMutationOptions = Apollo.BaseMutationOptions<
  UpdateEmployeeEmergencyContactMutation,
  UpdateEmployeeEmergencyContactMutationVariables
>;
